<template>
  <div class="flex items-center h-screen w-full bg-gray-300">
    <div class="w-full bg-white rounded-lg shadow-lg p-8 m-4 md:max-w-sm md:mx-auto">
      <div class="flex flex-col w-full pl-4">
        <form class="w-full max-w-lg" id="passwordChangeForm" @submit.prevent="updatePassword">
          <div class="w-full text-left pb-3 text-gray-900 text-2xl font-bold">Cambió de Contraseña</div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="email"
              >Contraseña</label>
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
                id="password"
                type="password"
                name="password"
                v-model="password"
              />
              <p
                    v-if="errors.password"
                    class="text-red-500 text-xs italic"
                  >Ingrese una contraseña.</p>
                  <p
                    v-if="errors.valid_password"
                    class="text-red-500 text-xs italic"
                  >La contraseña no coincide.</p>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="email_again"
              >Repetir Contraseña</label>
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
                id="password_again"
                type="password"
                name="password_again"
                v-model="password_again"
              />
            </div>
            <p
            v-if="errors.password_again"
            class="text-red-500 text-xs italic"
            >Ingrese una contraseña.</p>
          </div>
          <div class="flex w-full justify-end pt-6">
            <button
            type="submit" class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wider uppercase font-bold"
            >Actualizar</button>
          </div>
        </form>
      </div>
    </div>
    <reset-password-modal
        :showing="showResetPasswordModal"
        @close="showResetPasswordModal = false"
        ></reset-password-modal>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Contraseña actualizada exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="sendLogin"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingVerifyToken">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Token Caducado</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="messageVerifyToken"
        >Aceptar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<style scoped>
</style>

<script>
import { mapState, mapActions } from "vuex";
import ResetPassword from "./ResetPassword";
import axios from 'axios';
import AlertDialog from "./AlertDialog";

export default {
  data() {
    return {
      password: null,
      password_again: null,
      showResetPasswordModal: false,
      token: "",
      errors: {
        password: false,
        password_again: false,
        valid_password: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      showingVerifyToken: false,
    };
  },
  components: {
    'reset-password-modal': ResetPassword,
    AlertDialog
  },
  methods: {
    openResetPasswordModal(){
      this.showResetPasswordModal = true;
    },
    verifyToken(){
        this.token = this.$router.history.current.query.token;
        this.axios
            .get("apidev/users/reset_password?token="+ this.token)
            .then(response => {

            })
            .catch(error =>{
              // removed console log
              if (error.response.status == 400){
                this.showingVerifyToken = true
              }
              // if (error.response.status == 400 || error.response.status == 401) {
              //   if (error.response.data.name === 'TokenExpiredError' || 
              //       error.response.data.name === 'InvalidTokenError' || 
              //       error.response.data.name === 'JsonWebTokenError') {
              //    this.$router.push({path: '/login'}); 
              //   }
              // }
            });
    },
    updatePassword(){
        const form = document.getElementById("passwordChangeForm");
        const signInData = new FormData(form);
        const validForm = this.checkFormUpdatePassword(signInData);
        if (validForm) {
            this.axios
                .post("apidev/users/update_password",
                {
                    token: this.token,
                    password: this.password   
                })
                .then(response => {
                    this.showingSuccess = true;
                })
                .catch(error =>{
                    // removed console log
                    if (error.response.status == 400 || error.response.status == 401) {
                      if (error.response.data.name === 'TokenExpiredError' || 
                          error.response.data.name === 'InvalidTokenError' || 
                          error.response.data.name === 'JsonWebTokenError') {
                      this.$router.push({path: '/login'}); 
                      }
                    }
                    this.showingError = true;
                });
        }
    },
    checkFormUpdatePassword: function(signInData) {
      if (signInData.get("password") === "") {
        this.errors.password = true;
      } else {
        this.errors.password = false;
      }

      if (signInData.get("password_again") === "") {
        this.errors.password_again = true;
      } else {
        this.errors.password_again = false;
      }

      if (signInData.get("password") !== signInData.get("password_again")) {
        this.errors.valid_password = true;
        return false;
      } else {
        this.errors.valid_password = false;
      }

      if (
        this.errors.password ||
        this.errors.password_again ||
        this.errors.valid_password
      ) {
        return false;
      }

      return true;
    },
    messageVerifyToken(){
      this.showingVerifyToken = false; 
      this.$router.push({path: '/login'});
    },
    sendLogin(){
      this.showingSuccess = false;
      this.$router.push({path: '/login'});
    }
  },
  mounted(){
    this.verifyToken()
    
  }
};
</script>
